interface UseBrowserDownloadOptions {
  revokeDelayMs?: number;
}

const isBrowserDownloadAvailable = (): boolean => {
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof URL !== 'undefined' &&
    typeof URL.createObjectURL === 'function' &&
    typeof URL.revokeObjectURL === 'function'
  );
};

export const useBrowserDownload = (options: UseBrowserDownloadOptions = {}) => {
  const { revokeDelayMs = 0 } = options;

  const triggerBrowserDownload = (blob: Blob, fileName: string): boolean => {
    if (!isBrowserDownloadAvailable()) {
      return false;
    }

    if (!document.body) {
      return false;
    }

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = fileName;
    link.style.display = 'none';

    try {
      document.body.append(link);
      link.click();

      return true;
    } finally {
      link.remove();

      // Revoke asynchronously to avoid revoking before download starts.
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, revokeDelayMs);
    }
  };

  return {
    triggerBrowserDownload,
  };
};
